export const fetchNotifications = resp => ({
  type: 'FETCH_NOTIFICATIONS',
  payload: resp
});

export const markNotificationAsRead = resp => ({
  type: 'MARK_NOTIFICATION_AS_READ',
  payload: resp
});
